import axios from 'axios';

export const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/admin`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
});
export const uploadFileClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/admin`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.token ? JSON.parse(localStorage.token) : null;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);


apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

uploadFileClient.interceptors.request.use(
  function (request) {
    const token = localStorage.token ? JSON.parse(localStorage.token) : null;
    if (token) {
      request.headers['Authorization'] = `Bearer ${token}`;
    }
    request.headers['Content-Type'] = 'multipart/form-data';
    return request;
  },
  null,
  { synchronous: true },
);

uploadFileClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return Promise.reject(error);
  },
);
